import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { toString } from 'lodash-es';
import type { ChangeEvent, SyntheticEvent } from 'react';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  SyncConfigurationEntityType,
  type SyncConfigurationEntityOption,
  type UseSyncConfigurationPageContentReturn,
} from './syncConfigurationPageContent.model';

export function useSyncConfigurationPageContent(): UseSyncConfigurationPageContentReturn {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.COMMON]);

  const entityOptions = useMemo<SyncConfigurationEntityOption[]>(
    () => [
      {
        label: toString(t('syncConfigurationPage.entityOptions.merchant')),
        value: SyncConfigurationEntityType.Merchant,
      },
      { label: toString(t('syncConfigurationPage.entityOptions.store')), value: SyncConfigurationEntityType.Store },
      { label: toString(t('syncConfigurationPage.entityOptions.device')), value: SyncConfigurationEntityType.Device },
    ],
    [t],
  );

  const [selectedEntity, setSelectedEntity] = useState<SyncConfigurationEntityOption | null>(null);
  const [singleId, setSingleId] = useState('');
  const [deviceIds, setDeviceIds] = useState<string[]>([]);

  const isDeviceEntitySelected = selectedEntity?.value === SyncConfigurationEntityType.Device;

  const idsSectionTitle = toString(
    t(isDeviceEntitySelected ? 'syncConfigurationPage.ids.titleMultiple' : 'syncConfigurationPage.ids.titleSingle'),
  );

  const handleEntityChange = useCallback((_: SyntheticEvent, value: SyncConfigurationEntityOption | null) => {
    setSelectedEntity(value);
    setSingleId('');
    setDeviceIds([]);
  }, []);

  const handleSingleIdChange = useCallback((_: ChangeEvent<HTMLInputElement>, __: string, value: unknown) => {
    setSingleId(toString(value));
  }, []);

  const handleDeviceIdsChange = useCallback((_: SyntheticEvent, value: string[]) => {
    setDeviceIds(value);
  }, []);

  const isTriggerActionDisabled =
    !selectedEntity || (isDeviceEntitySelected ? deviceIds.length === 0 : singleId.trim() === '');

  const handleTriggerAction = useCallback(() => {
    // TODO: wire this to the sync configuration trigger request once the backend contract is available
  }, []);

  return {
    entityOptions,
    selectedEntity,
    handleEntityChange,
    idsSectionTitle,
    isDeviceEntitySelected,
    singleId,
    handleSingleIdChange,
    deviceIds,
    handleDeviceIdsChange,
    isTriggerActionDisabled,
    handleTriggerAction,
  };
}
